export default __webpack_public_path__ + "static/media/IMG_4996-min.cc6d4315.JPG";